var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('li',{class:{ active:_vm.updated }},[_c('article',{staticClass:"story"},[_c('div',{staticClass:"bubble"},[_c('a',{style:('background-image: url(' + _vm.background + ')'),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openStory($event)}}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.title))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-572fa317","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoryBubble.vue
// module id = 221
// module chunks = 0